import React, { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import Item from "./Item";
import { Button, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link, NavLink, useHistory } from "react-router-dom";
import Group570 from "../static/Group570.png";
import PaginatioN from "react-js-pagination";
import { paginate } from "../utils/paginate";
import Loader from "../utils/loader";
import { getHomeBlogs, getHomeCMS } from "../services/adminServices";
import noblogs from "../static/emptyblogs.png";
import HeadingB from "./Cards/HeadingB";
import seoServices from "../services/seoServices";
import { getProducts } from '../services/productService';
import { paramCase } from "change-case";
// import {frontEndUrl,imgUrl} from "../services/config.json";
import configdata from '../services/config.json'

export function Blogpage({ category }) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = React.useState([]);
  const [navbarProducts, setNavbarProducts] = React.useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [pageItems] = useState(10);
  const [cms, setCms] = useState({});

  useEffect(() => {
    getBlogs();
    getCms();
  }, [currentPage]);

  const getBlogs = async () => {
    setLoading(true);
    let details = await seoServices.getSEOBlogsByCategoryWise(
      pageItems,
      currentPage,
      category
    );

    console.log("getBlogsdetails", details)
    if (details.status == 200) {
      setBlogs(details.data);
      setTotalItems(details.total);
    }
    let products = await getProducts();
    if (products.status == 200) {
      setNavbarProducts(products.data.products);
    }
    setLoading(false);
  };

  const getCms = async () => {
    let cms = await getHomeCMS();
    setCms(cms.data);
    // console.log(cms);
  };

  const handleAboutRoute = () => {
    if (process.env.NODE_ENV !== "production") {
      window.location.href = `${configdata.frontEndUrl}/#about`
    } else {
      window.location.href = "https://synthiumsuites.com/#about";
    }
  };

  const handleFeaturesRoute = () => {
    if (process.env.NODE_ENV !== "production") {
      window.location.href = `${configdata.frontEndUrl}/#features`
    } else {
      window.location.href =
        "https://synthiumsuites.com/#features";
    }
  };

  const handlePricingRoute = () => {
    if (process.env.NODE_ENV !== "production") {
      window.location.href = `${configdata.frontEndUrl}/#pricing`
    } else {
      window.location.href = "https://synthiumsuites.com/#pricing";
    }
  };

  const handleContactRoute = () => {
    if (process.env.NODE_ENV !== "production") {
      window.location.href = `${configdata.frontEndUrl}/#contacts`
    } else {
      window.location.href =
        "https://synthiumsuites.com/#contacts";
    }
  };

  const handleProductBlog = async (category) => {
    const product = {
      main_category: "products",
      category: category
    }
    const { data, status } = await seoServices.getProductSEOBlog(product);

    if (status === 200) {
      history.push({
        pathname: `/${paramCase(data.urlValue)}`,
        state: { detail: data }
      });
    } else {
      console.log('no blog found');
    }
  }

  return (
    <div>
      <Loader loading={loading} />

      <Navbar
        expand="lg"
        fixed="top"
        style={{
          backgroundColor: "#1976d2",
          paddingLeft: "7%",
        }}
      >
        <Navbar.Brand style={{ color: "white" }} href="/">
          <img
            className="petLogo"
            alt="Group570"
            style={{ width: "auto", height: "60px" }}
            src={
              cms && cms.Navbar_logo
                ? cms.Navbar_logo.Image
                : `${configdata.imgUrl}/pet-website-static-images/Group+571.png`
            }
          // src={Group570}
          ></img>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="navLinks ml-auto" style={{ marginRight: "20%" }}>
            <Nav.Link
              className="loginLink"
              style={{ color: "white", marginLeft: "10%" }}
            >
              <NavLink className="text-white ft_md" to={{ pathname: "/" }}>
                Home
              </NavLink>
            </Nav.Link>
            <Nav.Link className="ft_md text-white">
              <span className="text-white ft_md" onClick={handleAboutRoute}>
                About
              </span>
            </Nav.Link>
            <Nav.Link className="ft_md text-white">
              <span className="text-white ft_md" onClick={handleFeaturesRoute}>
                Features
              </span>
            </Nav.Link>
            <Nav.Link className="ft_md text-white">
              <span className="text-white ft_md" onClick={handlePricingRoute}>
                Pricing
              </span>
            </Nav.Link>
            <Nav.Link className="ft_md text-white">
              <span className="text-white ft_md" onClick={handleContactRoute}>
                Contact
              </span>
            </Nav.Link>
            <Nav.Link className="ft_md text-white">
              <span className="text-white ft_md" onClick={null}>
                Blogs
              </span>
            </Nav.Link>

            <NavDropdown title="Products" id="basic-nav-dropdown">
              {navbarProducts.map(product => (
                <NavDropdown.Item onClick={() => handleProductBlog(product)}>
                  {(product.charAt(0).toUpperCase() + product.slice(1)).replace(/_/g, ' ')}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            <Nav.Link
              className="loginLink"
              style={{ color: "white", marginLeft: "10%" }}
            >
              <NavLink className="text-white ft_md" to={{ pathname: "/login" }}>
                Login
              </NavLink>
            </Nav.Link>
            &nbsp;&nbsp;
            <Link to={{ pathname: "/signup" }}>
              <Button
                className="ft_md"
                style={{
                  textAlign: "center",
                  color: "#4085f6",
                  borderRadius: "20px",
                  paddingLeft: "30px",
                  paddingRight: "30px",
                  backgroundColor: "white",
                }}
              >
                SignUp
              </Button>
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <div className="container" style={{ marginTop: "7%" }}>
        <div id="mainPreview" className="mt-5">
          <div className="row">
            {blogs.length > 0 ? (
              <>
                {blogs.map((item) => (
                  <div className="col-md-6">
                    <Item item={item} allBlogs={blogs} />
                  </div>
                ))}
              </>
            ) : (
              <div className="text-center">
                <img
                  src={noblogs}
                  style={{
                    height: "60%",
                    width: "60%",
                    marginTop: "5%",
                    marginBottom: "5%",
                  }}
                />
                <HeadingB
                  className="alertHead"
                  text="No Blog Published Yet..!"
                />
              </div>
            )}
          </div>
          {totalItems > pageItems ? (
            <div className="mt-5" style={{ float: "right" }}>
              <PaginatioN
                activePage={currentPage}
                itemsCountPerPage={pageItems}
                totalItemsCount={totalItems}
                pageRangeDisplayed={3}
                onChange={(page) => setCurrentPage(page)}
                itemClass="page-item"
                linkClass="page-link"
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default Blogpage;




// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Card,
//   CardContent,
//   Chip,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Paper,
//   Divider,
// } from "@mui/material";
// import Grid2 from "@mui/material/Unstable_Grid2"; // MUI Grid2

// const primaryPurposes = [
//   {
//     title: "Brand Authority",
//     description:
//       "Positions your platform as an expert through insightful articles, case studies, and thought leadership pieces.",
//   },
//   {
//     title: "Organic Traffic (SEO)",
//     description:
//       "Blogs help your product rank higher in search engines, generating steady, non-paid leads.",
//   },
//   {
//     title: "Feature Education",
//     description:
//       "Explains product updates, new modules, use cases, and best practices, reducing confusion and support load.",
//   },
//   {
//     title: "User Engagement",
//     description:
//       "Keeps customers informed, builds trust, reduces support tickets, and increases platform retention.",
//   },
//   {
//     title: "Content Marketing",
//     description:
//       "Drives campaigns, newsletters, and social funnels while giving your sales team rich storytelling material.",
//   },
// ];

// const comparisonRows = [
//   {
//     feature: "Primary Use",
//     grammarly: "Grammar, tone, and clarity improvements.",
//     quillbot: "Paraphrasing, rewriting, and summarization.",
//     relevance: "Blog drafts get corrected vs. restructured.",
//   },
//   {
//     feature: "Strength",
//     grammarly: "Error detection, professional tone, readability.",
//     quillbot: "Rewriting sentences and avoiding plagiarism.",
//     relevance: "Improves originality and rewriting depth.",
//   },
//   {
//     feature: "Best For",
//     grammarly: "Final polishing of blog posts.",
//     quillbot: "Generating alternative versions of content.",
//     relevance: "Helps maintain both quality and creativity.",
//   },
//   {
//     feature: "Uniqueness",
//     grammarly: "Real-time suggestions and tone detection.",
//     quillbot:
//       "Multiple paraphrasing modes (formal, creative, concise, etc.).",
//     relevance: "Offers stylistic flexibility for different audiences.",
//   },
//   {
//     feature: "SEO Impact",
//     grammarly: "Ensures clean, human-readable content.",
//     quillbot: "Creates plagiarism-safe content variations.",
//     relevance: "Supports scalable SEO-friendly content creation.",
//   },
//   {
//     feature: "Writer Skill Dependency",
//     grammarly: "Great for writers who already draft content.",
//     quillbot: "Helps non-writers rephrase complex ideas.",
//     relevance: "Supports different roles in your content team.",
//   },
// ];

// const stageRows = [
//   {
//     stage: "Drafting",
//     grammarly: "—",
//     quillbot: "Helps convert rough thoughts into readable text.",
//   },
//   {
//     stage: "Editing",
//     grammarly: "Fixes grammar, tone, and punctuation.",
//     quillbot: "Provides alternative sentence structures.",
//   },
//   {
//     stage: "Finalizing",
//     grammarly: "Ensures professional, publication-ready quality.",
//     quillbot: "Avoids duplicate content risk with fresh rewrites.",
//   },
// ];

// const Blogpage = () => {
//   return (
//     <Box sx={{ bgcolor: "#0f172a", minHeight: "100vh", py: 8 }}>
//       <Container maxWidth="lg">
//         {/* HERO / INTRO */}
//         <Box
//           sx={{
//             mb: 6,
//             p: { xs: 3, md: 4 },
//             borderRadius: 4,
//             background:
//               "linear-gradient(135deg, rgba(102,126,234,0.12), rgba(118,75,162,0.12))",
//             border: "1px solid rgba(148,163,184,0.3)",
//           }}
//         >
//           <Chip
//             label="Blogs & Insights"
//             sx={{
//               mb: 2,
//               bgcolor: "rgba(148,163,184,0.15)",
//               color: "#e2e8f0",
//               textTransform: "uppercase",
//               letterSpacing: "0.08em",
//               fontSize: 12,
//             }}
//           />
//           <Typography
//             variant="h3"
//             sx={{
//               fontWeight: 800,
//               mb: 2,
//               color: "#f9fafb",
//             }}
//           >
//             What Is the Use of a Blogs Screen?
//           </Typography>
//           <Typography
//             variant="body1"
//             sx={{ color: "#cbd5f5", maxWidth: 840, lineHeight: 1.7 }}
//           >
//             A Blogs Screen in your SaaS platform is a centralized space for
//             publishing articles, updates, announcements, guides, and educational
//             content. It is more than a static page—it is a strategic engine for
//             growth, trust-building, and user conversion.
//           </Typography>
//         </Box>

//         {/* PRIMARY PURPOSES */}
//         <Grid2 container spacing={3} sx={{ mb: 6 }}>
//           <Grid2 xs={12} md={4}>
//             <Typography
//               variant="h5"
//               sx={{ color: "#e5e7eb", fontWeight: 700, mb: 1 }}
//             >
//               Primary Purposes
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{ color: "#9ca3af", maxWidth: 320, lineHeight: 1.6 }}
//             >
//               Each blog post becomes a touchpoint that strengthens your product
//               narrative and deepens user understanding.
//             </Typography>
//           </Grid2>

//           <Grid2 xs={12} md={8}>
//             <Grid2 container spacing={2}>
//               {primaryPurposes.map((item) => (
//                 <Grid2 xs={12} sm={6} key={item.title}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       bgcolor: "#020617",
//                       borderRadius: 3,
//                       border: "1px solid rgba(51,65,85,0.7)",
//                     }}
//                   >
//                     <CardContent>
//                       <Typography
//                         variant="subtitle1"
//                         sx={{
//                           color: "#e5e7eb",
//                           fontWeight: 600,
//                           mb: 1,
//                         }}
//                       >
//                         {item.title}
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "#9ca3af", lineHeight: 1.6 }}
//                       >
//                         {item.description}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid2>
//               ))}
//             </Grid2>
//           </Grid2>
//         </Grid2>

//         {/* COMPARISON TABLE */}
//         <Box sx={{ mb: 6 }}>
//           <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1 }}>
//             <Typography
//               variant="h5"
//               sx={{ color: "#e5e7eb", fontWeight: 700 }}
//             >
//               Grammarly vs QuillBot
//             </Typography>
//             <Chip
//               label="Comparative Analysis"
//               size="small"
//               sx={{
//                 bgcolor: "rgba(148,163,184,0.15)",
//                 color: "#cbd5f5",
//                 ml: 1,
//               }}
//             />
//           </Box>

//           <Typography
//             variant="body2"
//             sx={{ color: "#9ca3af", mb: 2, maxWidth: 720 }}
//           >
//             Both tools support your Blogs Screen, but they play different roles:
//             QuillBot helps create and rebuild content, while Grammarly refines
//             and perfects it.
//           </Typography>

//           <Paper
//             sx={{
//               bgcolor: "#020617",
//               borderRadius: 3,
//               overflow: "hidden",
//               border: "1px solid rgba(51,65,85,0.6)",
//             }}
//           >
//             <Table size="small">
//               <TableHead>
//                 <TableRow>
//                   <TableCell sx={{ color: "#9ca3af", fontWeight: 600 }}>
//                     Feature
//                   </TableCell>
//                   <TableCell sx={{ color: "#9ca3af", fontWeight: 600 }}>
//                     Grammarly
//                   </TableCell>
//                   <TableCell sx={{ color: "#9ca3af", fontWeight: 600 }}>
//                     QuillBot
//                   </TableCell>
//                   <TableCell sx={{ color: "#9ca3af", fontWeight: 600 }}>
//                     Relevance to Blogs Screen
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {comparisonRows.map((row) => (
//                   <TableRow key={row.feature}>
//                     <TableCell sx={{ color: "#e5e7eb" }}>
//                       {row.feature}
//                     </TableCell>
//                     <TableCell sx={{ color: "#cbd5f5" }}>
//                       {row.grammarly}
//                     </TableCell>
//                     <TableCell sx={{ color: "#cbd5f5" }}>
//                       {row.quillbot}
//                     </TableCell>
//                     <TableCell sx={{ color: "#9ca3af" }}>
//                       {row.relevance}
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </Paper>
//         </Box>

//         {/* STAGES SECTION */}
//         <Grid2 container spacing={3} sx={{ mb: 6 }}>
//           <Grid2 xs={12} md={4}>
//             <Typography
//               variant="h5"
//               sx={{ color: "#e5e7eb", fontWeight: 700, mb: 1 }}
//             >
//               How They Connect to Your Blog Screen
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{ color: "#9ca3af", lineHeight: 1.6 }}
//             >
//               From drafting to final publishing, Grammarly and QuillBot cover
//               different layers of your content pipeline.
//             </Typography>
//           </Grid2>
//           <Grid2 xs={12} md={8}>
//             <Paper
//               sx={{
//                 bgcolor: "#020617",
//                 borderRadius: 3,
//                 p: 2,
//                 border: "1px solid rgba(51,65,85,0.6)",
//               }}
//             >
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell sx={{ color: "#9ca3af", fontWeight: 600 }}>
//                       Blog Stage
//                     </TableCell>
//                     <TableCell sx={{ color: "#9ca3af", fontWeight: 600 }}>
//                       Grammarly’s Role
//                     </TableCell>
//                     <TableCell sx={{ color: "#9ca3af", fontWeight: 600 }}>
//                       QuillBot’s Role
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {stageRows.map((row) => (
//                     <TableRow key={row.stage}>
//                       <TableCell sx={{ color: "#e5e7eb" }}>
//                         {row.stage}
//                       </TableCell>
//                       <TableCell sx={{ color: "#cbd5f5" }}>
//                         {row.grammarly}
//                       </TableCell>
//                       <TableCell sx={{ color: "#cbd5f5" }}>
//                         {row.quillbot}
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </Paper>
//           </Grid2>
//         </Grid2>

//         {/* SUMMARY */}
//         <Box
//           sx={{
//             p: { xs: 3, md: 4 },
//             borderRadius: 4,
//             bgcolor: "#020617",
//             border: "1px solid rgba(51,65,85,0.7)",
//           }}
//         >
//           <Typography
//             variant="h5"
//             sx={{ color: "#e5e7eb", fontWeight: 700, mb: 2 }}
//           >
//             Why Invest in a Dedicated Blogs Screen?
//           </Typography>
//           <Typography
//             variant="body1"
//             sx={{ color: "#cbd5f5", mb: 2, lineHeight: 1.7 }}
//           >
//             A Blogs Screen in your platform:
//           </Typography>

//           <Grid2 container spacing={1} sx={{ mb: 2 }}>
//             {[
//               "Builds credibility and brand authority.",
//               "Boosts SEO and organic discovery.",
//               "Educates users on features, workflows, and best practices.",
//               "Increases engagement, activation, and retention.",
//             ].map((item) => (
//               <Grid2 xs={12} md={6} key={item}>
//                 <Typography
//                   variant="body2"
//                   sx={{ color: "#9ca3af", lineHeight: 1.7 }}
//                 >
//                   • {item}
//                 </Typography>
//               </Grid2>
//             ))}
//           </Grid2>

//           <Divider sx={{ borderColor: "rgba(51,65,85,0.9)", my: 2 }} />

//           <Typography
//             variant="body2"
//             sx={{ color: "#9ca3af", lineHeight: 1.7 }}
//           >
//             Paired with tools like <strong>QuillBot</strong> for content
//             creation and <strong>Grammarly</strong> for refinement, your Blogs
//             Screen becomes a scalable engine for publishing original, polished,
//             and high-impact content that supports every part of your SaaS
//             lifecycle.
//           </Typography>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default Blogpage;
